<template>
  <lottie
    :height="height"
    :options="options"
    :width="width"
    @animCreated="handleAnimation"
  />
</template>

<script>
export default {
  name: 'finLottieSwitch',
  components: {Lottie: () => import('vue-lottie')},
  props: {
    options: {},
    height: {
      type: [Number, String]
    },
    width: {
      type: [Number, String]
    },
    animate: {
      type: Boolean
    }
  },
  data() {
    return {
      anim: null
    }
  },
  methods: {
    handleAnimation: function (anim) {
      this.anim = anim
    }
  },
  beforeDestroy() {
    this.anim?.destroy()
  },
  watch: {
    animate() {
      if (this.anim) {
        if (this.animate) {
          this.anim.play()
        } else {
          this.anim.stop()
        }
      }
    }
  }
}
</script>

<style scoped>

</style>
